import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import moment from 'moment';
import { DATE_FORMAT } from 'app/shared/constants/input.constants';
import { map } from 'rxjs/operators';
import { INotificationMessageRx } from 'app/shared/model/notification-message-rx.model';
import AppConfigService from 'app/core/app-config.service';

type EntityResponseType = HttpResponse<INotificationMessageRx>;
type EntityArrayResponseType = HttpResponse<INotificationMessageRx[]>;

@Injectable({ providedIn: 'root' })
export default class NotificationMessageRxService {
  public resourceUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/notification-messages`;

  constructor(protected http: HttpClient) {}

  find(id: number): Observable<EntityResponseType> {
    return this.http
      .get<INotificationMessageRx>(`${this.resourceUrl}/${id}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      res.body.startDate = res.body.startDate != null ? moment(res.body.startDate) : null;
      res.body.endDate = res.body.endDate != null ? moment(res.body.endDate) : null;
    }
    return res;
  }

  submitNotificationSettings(data: any, method: string): Observable<any> {
    const parameters = new HttpParams().set('method', method);
    return this.http.put(`${AppConfigService.envConfig.fssServicesBaseUrl}api/user/update`, data, { params: parameters });
  }

  updatedNotificationConsent(payload) {
    return this.http.post(`${AppConfigService.envConfig.fssServicesBaseUrl}api/user/notification-consent`, payload);
  }
}
